import { submitGuard } from './alpine-submit-guard.js';

/**
 * The /app/feedback contact form. x-data sits on the <form>.
 *
 * POST /app/feedback runs an AI classification, an S3 attachment upload and two
 * third-party notifications before it answers, so a submission regularly takes
 * several seconds. Without the latch the page collects a second copy from the
 * next press, and the support thread shows the same message twice.
 */
export function feedbackForm() {
    return {
        ...submitGuard(),

        init() {
            this.initSubmitGuard();
        },

        /**
         * The topic is carried in a hidden input, which browsers bar from
         * constraint validation, so checkValidity() cannot block an empty one.
         */
        prepareSubmit(event) {
            const topicInput = this.$root.querySelector('#topicInput');
            if (topicInput !== null && topicInput.value === '') {
                event.preventDefault();
                this.showTopicError();

                return false;
            }

            return true;
        },

        showTopicError() {
            const selector = this.$root.querySelector('[x-data*="topicSelector"]');
            if (selector === null || !window.Alpine) {
                return;
            }

            const data = window.Alpine.$data(selector);
            if (data) {
                data.showError = true;
            }
        },
    };
}
